<template>
  <v-app id="inspire">
    <router-view />
    <Error />
    <FirebaseRealtimeDb />

  </v-app>
</template>

<script>
import Error from "@/components/Errors";

import FirebaseRealtimeDb from '@/views/Admin/FirebaseRealtimeDb';

export default {
  name: "App",
  components: {
    Error,
    FirebaseRealtimeDb,
  },
  data() {
    return {
    }
  },
  methods: {
    clearStorage() {
      if(localStorage.getItem('pagination_page')){
        localStorage.setItem('pagination_page', 0)
      }
    }
  },
  watch: {
    group() {
      this.drawer = false;
    },
    showMenu() {
      let type = localStorage.getItem('type')
      this.showMenu = type
    },
  },
};
</script>

<style>
#inspire {
  font-family: Circe;
}
.adaptive-container {
  max-width: 1600px !important;
}

@media (min-width: 1264px) and (max-width: 1390px) {
  .adaptive-container {
    max-width: 1050px !important;
  }
  .container {
    max-width: 1050px !important;
  }
}

.page-top {
  margin-top:50px;
}
.page-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}
.page-subtitle {
  margin-top: 30px;
  font-weight: 700;
  font-size: 25px;
  line-height: 32px;
}
.breadcrumb {
  margin-top: 5px;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #767676;
}
.breadcrumb-bold {
  color: #000;
}
.button > span {
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
  text-indent: 0 !important;
}
.back__button {
  gap: 15px;
  padding: 0 !important;
  min-width: 48px !important;
  min-height: 38px !important;
  background-color: #fff !important;
  border-radius: 12px !important;
  border: #E0E0E0 solid 1px!important;
  box-shadow: none!important;
  margin-top: -15px!important;
  margin-right: 15px!important;
}
.button__lighten {
  box-shadow: none !important;
  padding: 8px 16px !important;
  border-radius: 12px !important;
  background: #F1F1F1 !important;
}
.button__lighten > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__lighten-success {
  box-shadow: none !important;
  margin-top: 20px !important;
  padding: 8px 20px !important;
  border: 1px solid #629F33 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: #629F33 !important;
}
.button__lighten-success > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__success {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 12px !important;
  background: #629F33 !important;
  color: #fff !important;
}
.button__success > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.button__danger {
  box-shadow: none !important;
  margin-top: 20px !important;
  padding: 8px 25px !important;
  border-radius: 8px !important;
  background: #D53025 !important;
  color: #fff !important;
}
.button__danger > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__unlock {
  box-shadow: none !important;
  margin-top: 20px !important;
  padding: 8px 25px !important;
  border-radius: 8px !important;
  background: #629F33 !important;
  color: #fff !important;
}
.button__unlock > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__secondary {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 12px !important;
  background:  #E0E0E0 !important;
  color: #000 !important;
}
.sale-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #629F33 !important;
  margin-left: 10px;
  color: #fff !important;
}
.sale-button > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.return-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #D53025!important;
  font-size: 12px!important;
  margin-left: 10px;
  color: #fff!important;
}
.return-button > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.payment-button {
  box-shadow: none !important;
  border-radius: 12px!important;

  font-size: 12px!important;
  margin-left: 10px;

}
.payment-button > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.exit-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #A13453!important;
  font-size: 12px!important;
  margin-left: 10px;
  color: #fff!important;
}
.exit-button > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.button__activate {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  background: #FFB800 !important;
  color: #000 !important;
}
.button__activate > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__unblock {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  background: #629F33 !important;
  color: #fff !important;
}
.button__unblock > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}
.button__block {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  background: #D53025 !important;
  color: #fff !important;
}
.button__block > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}

.button__activate {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  background: #FFB800 !important;
  color: #fff !important;
}
.button__activate > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}

.button__disabled {
  box-shadow: none !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  background: #E0E0E0 !important;
  color: #fff !important;
}
.button__disabled > span {
  font-family: 'Circe' !important;
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  text-transform: none !important;
}

.lessons_status_text_red{
  color: red;
}

.lessons_status_text_green{
  color: green;
}

.card {
  padding: 20px;
}
.card-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.card-subtitle {
  color: #1A1A1A;
  opacity: 0.5;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
}
.note-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
}

.list-item__title {
  font-weight: 700;
  flex: 1 0 50% !important;
}
.list-item__value {
  font-weight: 400;
  text-align: right;
  flex: 1 0 50% !important;
}
.left-sidebar{
  width: 210px!important;
  background-color: #fff!important;
}
.theme--light.v-navigation-drawer{
  background-color: #fff!important;
}

.v-application .grey.lighten-3{
  background-color: #F1F1F1!important;
}

.header-layout{
  height: 78px!important;
}

.search-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #629F33!important;
  margin-left: 10px;
  margin-top: -27px!important;
  color: #fff !important;
}
.search-button > span {
  font-family: 'Circe' !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
  text-indent: 0 !important;
}

.filter-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #A13453!important;
  margin-left: 10px;
  color: #fff !important;
}
.filter-button > span {
  font-family: 'Circe' !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
  text-indent: 0 !important;
}

.apply-button {
  box-shadow: none !important;
  border-radius: 12px!important;
  background-color: #F1F1F1 !important;
  color: #1A1A1A!important;
  margin: 0 !important;
  width: 355px;
  padding: 22px 0 !important;
}
.apply-button > span {
  font-family: 'Circe' !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
  text-indent: 0 !important;
}

.tooltip-top:before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: '';
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}
.tooltip-checkbox:before {
  transform: translateX(0%) !important;
}
.tooltip-top.black:before{
  border-top: solid 8px #000;
}

.v-tab:before{
  background-color: #fff!important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #F1F1F1!important;
  border: 1px solid #E0E0E0!important;

}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content) {
  background: #fff !important;
}

.elevation-2 .v-data-table__wrapper{
  border-radius: 15px!important;
}
.v-text-field {
  border-radius: 12px !important;
}

.v-data-table .elevation-1 .theme--light{
  background-color: #0a58ca!important;
}

.elevation-1 > .v-data-table__wrapper > table > tbody > tr > td {
  border-width: 1px 0px 0px 1px;
  border-style: solid;
  border-color: #E0E0E0;
}

.v-pagination > li > .v-pagination__navigation .v-icon {
  color: #629F33 !important;
}
.v-pagination > li > .v-pagination__navigation {
  box-shadow: none !important;
}
.v-pagination > li > .v-pagination__item {
  box-shadow: none !important;
  color: #629F33 !important;
}
.v-pagination > li > .v-pagination__item--active {
  color: #ffffff !important;
}
.v-pagination > li > .v-pagination__navigation--disabled {
  opacity: 0 !important;
}
.v-pagination > li > .v-pagination__more {
  color: #629F33 !important;
}
.v-card__actions {
  justify-content: space-between;
}
.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content {
  color: #629F33;
}
.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > i {
  color: #629F33;
}

.no-active__toggle> .v-btn.v-btn--active > .v-btn__content {
  color: currentColor !important;
  opacity: 0.8 !important;
}
.no-active__toggle> .v-btn.v-btn--active > .v-btn__content > i {
  color: #000000 !important;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  min-height: 38px!important;
  color: #767676!important;
}

#horizontal_tabs > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  border-radius: 12px !important;
}

#horizontal_tabs > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: center !important;
}

#sub_tabs > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  border-radius: 12px 12px 0 0 !important;
  border-bottom: 2px solid #629F33;
}

#sub_tabs > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: center !important;
}

.custom__tab > .v-slide-group > .v-slide-group__wrapper {
  display: flex;
  justify-content: center;
}

.custom__tab > .v-slide-group > .v-slide-group__wrapper > .v-slide-group__content {
  flex: none !important;
}

.sale__tab > .v-slide-group {
  height: auto !important;
}

#vertical_tabs > .v-slide-group > .v-slide-group__wrapper {
  padding: 10px 0 !important;
}

.v-tabs.theme--light {
  border-radius: 20px !important;
  width: 98% !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  justify-content: start !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #E0ECD6 !important;
  border-radius: 0 !important;
  color: #629F33 !important;
  height: 40px !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: start !important;
  text-transform: none !important;
  text-align: left !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #767676 !important;
  height: 40px !important;
  padding: 8px 12px !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

/* .v-navigation-drawer__content {
  overflow-y: hidden !important;
} */
.v-dialog > label {
  color: #000 !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 38px !important;
  min-width: 64px !important;
}
.sale-page.primary--text {
  color: black !important;
  caret-color: black !important;
}
.services {
  width: 100%;
  padding: 0px 16px;
  gap: 16px;
  background: #F1F1F1;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  margin-top: 10px;
}
.services:hover,
.services:focus {
  background: #F1F1F1;
}
.services:hover::before,
.services:focus::before {
  background: none;
  opacity: 0 !important;
}

.v-treeview-node__root:hover::before {
  background-color: unset !important;
  opacity: 0 !important;
}

.debts > .v-list-item {
  padding: 0 !important;
}
.debts > .v-list-group__items > .v-list-item {
  padding: 0 !important;
}
.debts > .v-list-group__header:hover,
.debts > .v-list-group__header:focus {
  background: none;
}
.debts > .v-list-group__header:hover::before,
.debts > .v-list-group__header:focus::before {
  background: none;
  opacity: 0 !important;
}
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: #629F33 !important;
}
.theme--light.v-label--is-disabled {
  color: #000 !important;
}

.v-calendar .v-event-timed-container {
  margin-right: 0 !important;
}
.v-calendar-daily__scroll-area {
  overflow: hidden !important;
}
.v-calendar-daily__head {
  margin-right: 0 !important;
}
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
  border-color: #E0E0E0 !important;
}
.table__select fieldset {
  border: none !important;
}
.custom__calendar .v-calendar-daily_head-day .v-calendar-daily_head-weekday {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  text-align: left !important;
  color: #000 !important;
  padding: 10px 12px;
}
.custom__calendar .v-calendar-daily__head {
  background: #F1F1F1 !important;
}
.custom__calendar .v-calendar-daily__intervals-head {
  background: #F1F1F1 !important;
}
.custom__client-calendar .v-calendar-daily_head-weekday {
  display: none;
}
.custom__client-calendar .v-calendar-daily__head {
  background: #F1F1F1 !important;
}
.show__all-category .v-calendar-daily__body {
  width: fit-content !important;
}
.custom__client-calendar .v-calendar-daily__intervals-head {
  background: #F1F1F1 !important;
}
.custom__client-calendar .v-calendar-category__category {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  text-align: left !important;
  padding: 10px 12px;
}

.v-menu__content.theme--light.rounded-lg.v-menu__content--fixed.menuable__content__active.v-autocomplete__content::-webkit-scrollbar {
  -webkit-appearance: none;
  background-color: #FFF;
  width: 7px;
}
.v-menu__content.theme--light.rounded-lg.v-menu__content--fixed.menuable__content__active.v-autocomplete__content::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
}
.v-menu__content.theme--light.rounded-lg.v-menu__content--fixed.menuable__content__active.v-autocomplete__content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #C7C7C8;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.diagram > .v-progress-linear__content {
  justify-content: start!important;
  left: 10px !important;
}
</style>

